<template>
  <div class="offer-card">
    <div class="grid-x grid-margin-x">
      <div
        class="offer-card__content small-12 cell flex-container flex-dir-column"
      >
        <h3
          class="t-card mb-8 o-h"
          v-text="card.title"
        ></h3>
        <p class="t-p-medium mb-16" v-text="card.address"></p>
        <div class="pt-16" v-if="card.distance">
          <p class="offer-tags-spacing">
            <span
              class="offer-tag t-label-regular inline-block-top bg-light-gray"
              v-text="card.distance"
            ></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CardAmenity',
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>
